var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"STYLE":"text-align: center; font-size: 30px; font-weight: bold; padding: 20px"}},[_vm._v("\n    このサイトでは Cookie を使用しています。 ご利用を継続するにはCookie を有効にしてください。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }